import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { GraduationCap, Award, Users, Leaf } from 'lucide-react';

const FoundationSpotlight = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  const features = [
    {
      icon: GraduationCap,
      title: "Education & Courses",
      description: "Educational meetings and courses serving as a primary resource for industry knowledge"
    },
    {
      icon: Award,
      title: "Research & Scholarships",
      description: "Funding research and supporting the next generation of precious metals professionals"
    },
    {
      icon: Leaf,
      title: "Sustainable Practices",
      description: "Promoting environmentally sound use, reuse, and recycling of precious metals"
    }
  ];

  return (
    <section className="foundation-spotlight-section" ref={sectionRef}>
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="section-header centered"
        >
          <span className="section-eyebrow">The IPMI Foundation</span>
          <div className="foundation-logo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_44d33726-9765-4e8e-847d-5c309a2dbcb0/artifacts/47g66p6c_IPMI-Foundation-50th-Logo-White.svg"
              alt="IPMI Foundation 50th Anniversary"
              className="foundation-section-logo"
            />
          </div>
          <h2 className="section-title">Our Charitable & Educational Mission</h2>
          <p className="section-description-medium foundation-intro">
            The IPMI Scientific and Educational Foundation is our charitable affiliate—advancing precious metals 
            education, supporting research, and serving as a trusted resource for the public, industry, and 
            government agencies worldwide. Headquartered in the USA with chapters across North America and Europe.
          </p>
        </motion.div>

        {/* Feature Grid */}
        <div className="foundation-features-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                className="foundation-feature-card"
                initial={{ opacity: 0, y: 40 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.3 + (index * 0.15) }}
                whileHover={{ 
                  y: -8,
                  transition: { duration: 0.3 }
                }}
              >
                <motion.div className="feature-icon-wrapper">
                  <Icon className="feature-icon" size={28} />
                </motion.div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="foundation-cta-group"
        >
          <a 
            href="https://www.ipmi.org/foundation" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-primary-large"
          >
            Learn More About the Foundation
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FoundationSpotlight;
